import { MerchantProps } from './Merchant.type';

const Merchant = ({ title, partners }: MerchantProps) => (
  <div className="merchant-container">
    <h1>{title}</h1>
    <div className="partners">
      {partners.map((p) => (
        <div className="logo">{p}</div>
      ))}
    </div>
  </div>
);
export default Merchant;
